import { MantineThemeOverride } from "@mantine/core";

export const mantineTheme: MantineThemeOverride | undefined = {
  colorScheme: "light",
  fontFamily: "Poppins",
  headings: {
    fontFamily: "Poppins",
    sizes: {
      h1: { fontWeight: 700, fontSize: 40, lineHeight: 1.5 },
      h2: { fontWeight: 600, fontSize: 30, lineHeight: 1.5 },
      h3: { fontWeight: 500, fontSize: 20, lineHeight: 1.5 },
    },
  },
  colors: {
    primary: ["#F53B3B99"],
    success: ["#45CB85"],
    greyText: ["#00000099"],
  },

  primaryColor: "blue",
  loader: "bars",
};
